import { useMemo } from 'react';

/**
 * Wraps a value in an array if it is not `undefined`, otherwise returns `undefined`.  The result is memoized.
 *
 * @param value The value to wrap in an array.
 */
export function useValueAsTuple<T>(
    value: T | undefined
): [Exclude<T, undefined>] | undefined {
    return useMemo(
        () => (value === undefined ? undefined : ([value] as [Exclude<T, undefined>])),
        [value]
    );
}
